@for (d of designs; track trackById($index, d)) {
  <button
    type="button"
    class="bv-chip-design-picker__option"
    [class.bv-chip-design-picker__option--active]="value === d.id"
    [disabled]="disabled"
    [attr.aria-label]="d.id"
    (click)="pick(d.id)"
    >
    <bv-chip
      [denom]="null"
      [color]="$any({ p: primary, s: secondary })"
      [design]="d.id"
      [showLabel]="false"
      size="md"
    ></bv-chip>
  </button>
}
